import { BoxLoading } from "react-loadingg";

const BoxLoader = () => (
  <div
    style={{
      display: "flex",
      position: "absolute",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      width: "100%",
    }}
  >
    <BoxLoading
      color="linear-gradient(195deg, #49a3f1, #1A73E8)"
      style={{
        position: "fixed",
        zIndex: "5001",
      }}
    />
  </div>
);

export default BoxLoader;
